import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';

@Injectable()
export class PreviousRouteService {
  private router = inject(Router);


  private previousUrl: string;
  private currentUrl: string;

  public getPreviousUrl() {
    return this.previousUrl;
  }    

  public setPreviousUrl(url: string) {
    this.previousUrl = url;
  } 
}